import script from "./equipamentoAssociarFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./equipamentoAssociarFilter.vue?vue&type=script&setup=true&lang=js"

import "./equipamentoAssociarFilter.vue?vue&type=style&index=0&id=4c8a77b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8a77b3"]])

export default __exports__